import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export interface REGENERATE_SITE_DIALOG_PARAMS {
    prompt: string;
    triesCount: number;
    totalTries: number;
}

@Component({
    selector: 'regenerate-site-dialog',
    templateUrl: 'regenerate-site-dialog.component.html',
    styleUrls: ['regenerate-site-dialog.component.scss'],
})
export class RegenerateSiteDialogComponent {
    contentForm: FormGroup;

    showError: {
        prompt: boolean;
    };

    readonly promptMax: number = 300;

    actionsCountText: string = '';

    constructor(
        private fb: FormBuilder,
        public dialogRef: MatDialogRef<RegenerateSiteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public params: REGENERATE_SITE_DIALOG_PARAMS,
        private translate: TranslateService
    ) {
        this.showError = {
            prompt: false,
        };

        this.buildForm();

        switch (this.params?.triesCount) {
            case 1:
                this.actionsCountText = this.translate.instant(
                    'app.wizard.stepper_ia.dialogs.regenerate-site.esta_accion_utilizara',
                    { triesCount: this.params?.triesCount ?? 1, totalTries: this.params?.totalTries ?? 3 }
                );
                break;
            case 2:
                this.actionsCountText = this.translate.instant(
                    'app.wizard.stepper_ia.dialogs.regenerate-site.te_quedan_2_intentos'
                );
                break;
            case 3:
                this.actionsCountText = this.translate.instant(
                    'app.wizard.stepper_ia.dialogs.regenerate-site.ultimo_intento'
                );
                break;

            default:
                break;
        }
    }

    private buildForm(): void {
        this.contentForm = this.fb.group({
            promptUsuario: [this.params?.prompt ?? '', [Validators.required, Validators.maxLength(this.promptMax)]],
        });
    }

    updatePrompt(): void {
        const formData = this.contentForm.value;
        const promptUsuario = formData['promptUsuario'] as string;
        this.closeDialog(promptUsuario);
    }

    closeDialog(generatedText?: string): void {
        this.dialogRef.close(generatedText);
    }
}
